import {Component, EventEmitter, Input, Output} from '@angular/core';
import {faBan, faClock, faSign, faXmark} from '@fortawesome/free-solid-svg-icons';
import {
  StudentTicketListViewAsmResponseDTO
} from "../../../models/student-ticket/list-view/StudentTicketListViewAsmResponseDTO";
import {TicketTerminationStatusASM} from "../../../models/student-ticket/termination/TicketTerminationStatusASM";
import {
  getTicketTerminationStatusColor
} from "../../../models/student-ticket/termination/TicketTerminationStatusASMColorMapping";
import {TicketStatusASM} from "../../../models/student-ticket/TicketStatusASM";
import {BenutzerSessionService} from "../../../@core/services/benutzer/benutzer-session.service";

@Component({
    selector: 'app-ticket-termination-details',
    templateUrl: './ticket-termination-details.component.html',
    styleUrls: ['./ticket-termination-details.component.scss'],
    standalone: false
})
export class TicketTerminationDetailsComponent {

  @Input() ticket: StudentTicketListViewAsmResponseDTO;

  @Output() onApproveTicketTermination = new EventEmitter<void>();
  @Output() onCancelTicketTermination = new EventEmitter<void>();
  @Output() onTerminateTicket = new EventEmitter<void>();

  faTicketXmark = faXmark;
  faSign = faSign;
  faBan = faBan;
  faClock = faClock;

  constructor(
    readonly benutzerSessionService: BenutzerSessionService
  ) {}

  terminateTicket() {
    this.onTerminateTicket.emit();
  }

  cancelTicketTermination() {
    this.onCancelTicketTermination.emit();
  }

  protected readonly TicketTerminationStatusASM = TicketTerminationStatusASM;
  protected readonly getTicketTerminationStatusColor = getTicketTerminationStatusColor;
  protected readonly TicketStatusASM = TicketStatusASM;
}


